export class VoipQueueStatusRequest {
  url?: String;
  voipVendorId?: number;
}
